import { reactive, computed } from 'vue';
import { debounce } from '@/components/commons/utils.js';
import useLifecycleHook from './useLifecycleHook';
import ServerContextUtils from '../components/commons/ServerContextUtils';
const SSR_WIDTH = ServerContextUtils.getItem('isViewPortMobile') === true ? 767 : 1200;

const isBrowser = typeof window !== 'undefined';

const state = reactive({
  width: SSR_WIDTH,
});

const update = () => {
  state.width =
    window.innerWidth && document.documentElement.clientWidth
      ? Math.min(window.innerWidth, document.documentElement.clientWidth)
      : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
const updateDebounced = debounce(update, 1000);

if (isBrowser) {
  window.addEventListener('resize', updateDebounced);
  update();
}

export default function useResize() {
  const { mounted } = useLifecycleHook();
  const scopedWidth = computed(() => {
    return mounted.value ? state.width : SSR_WIDTH;
  });

  const isMobile = computed(
    () => scopedWidth.value < 768, //0~767. not a typo
  );

  const isTabletAndSmaller = computed(
    () => scopedWidth.value < 970, //0~969. not a typo
  );
  return {
    width: scopedWidth,
    isMobile,
    isTabletAndSmaller,
  };
}
